module.exports = __webpack_public_path__ + "img/ty-bg.112dced9.jpg";